/* import __COLOCATED_TEMPLATE__ from './next-steps.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();